/**************************************************
 * Nombre:       Dialogo_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {Outbox} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import Formulario_Soporte from "../Formularios/Formulario_Soporte";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {envioNotificacionWass} from "../../CodigoCliente/Notificaciones/envioNotificacionWass";
import {NUMEROWASS} from "../../Constantes";

const Dialogo_Soporte = ({cerrar, realizado, datos}) => {
    const cData = useContext(usuarioContext)
    const [cargando, setCargando] = useState(false)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()
        entidad.idUsuario = cData.usuario.id
        entidad.correo = cData.usuario.correo
        entidad.nombre = cData.usuario.nombre

        iniciarCarga('Creando Ticket')


        let imgDox = await subirImagenHostingFile(entidad.img)
        entidad.img = imgDox.data


        if (!entidad.id) {
            let doxConse = await obtenerConsecutivo({col: 'consecutivos', id: 'soporte'})
            entidad.consecutivo = doxConse.data
            await aumentarConsecutivo({col: 'consecutivos', id: 'soporte', actual: entidad.consecutivo})
        }


        let dox = await guardarDoc('soportes', entidad)
        if (dox.res) {
            terminar({aviso: 'Tikcet creado con exito, un colaborador tomara tu caso'})

        } else {
            terminar({aviso: 'Algo inesperado paso, porfavor intentalo nuevamente'})
        }

        await envioNotificacionWass({
            numero: NUMEROWASS,
            mensaje: `El usuario ${entidad.correo} con nombre ${entidad.nombre}, ha creado el sigueinte ticket de soporte \nTicket #${entidad.consecutivo}\n\n ${entidad.descripcion} `
        })

    }

    useEffect(() => {

        if (!datos || datos.estado) {
            props.setValue('estado', 'Abierto')
        }

    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Soporte props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 2}}>
                <Button
                    loading={cargando}
                    onClick={() => enviarDatos()}
                    startIcon={<Outbox/>}>Crear Ticket</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Soporte